export default {"src":"/_next/static/media/cardsphere.3128acf6.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};